import React, { Component } from 'react';
import KheshtiRug from './rugTemplates/kheshtiRug';
import AfshanRug from './rugTemplates/afshanRug';
import LachakToranjRug from './rugTemplates/lachakToranjRug';
import ModernRug from "./rugTemplates/modernRug";
import YourPicrureRug from "./rugTemplates/yourPicrureRug";

export default class SelectedRugsSidebar extends Component {

    render() {
        let rugs = [];
        this.props.rugs.map((rug, i) => {
            let key = rug.type + i
            switch (rug.type) {


                case "lachak-toranj":
                    rugs.push(
                        <li className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <LachakToranjRug
                                background={rug.background}
                                border={rug.border}
                                corner={rug.corner}
                                toranj={rug.toranj}
                                show={true}
                            />
                        </li>
                    );
                    break;
                case "kheshti":
                    rugs.push(
                        <li className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <KheshtiRug
                                background={rug.background}
                                tile={rug.tile}
                                show={true}
                            />
                        </li>
                    );
                    break;
                case "modern":
                    rugs.push(
                        <li className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <ModernRug
                                background={rug.background}
                                pattern={rug.pattern}
                                show={true}
                            />
                        </li>
                    );
                    break;
                case "your_picture":
                    rugs.push(
                        <li className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <YourPicrureRug
                                background={rug.background}
                                pattern={rug.pattern}
                                show={true}
                            />
                        </li>
                    );
                    break;
                default:
                    rugs.push(
                        <li className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <AfshanRug
                                background={rug.background}
                                border={rug.border}
                                show={true}
                            />
                        </li>
                    );
                    break;



                // case "lachak-toranj":
                //         rugs.push(
                //         <li className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                //             {/* <span> 23%</span> */}
                //             <LachakToranjRug
                //                 background={rug.background}
                //                 border={rug.border}
                //                 corner={rug.corner}
                //                 toranj={rug.toranj}
                //                 show={true}
                //             />
                //         </li>
                //     )
                //     break;
                // case "kheshti":
                //         rugs.push(
                //         <li className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                //             {/* <span> 23%</span> */}
                //             <KheshtiRug
                //                 background={rug.background}
                //                 tile={rug.tile}
                //                 show={true}
                //             />
                //         </li>
                //     )
                //     break;
                // default:
                //         rugs.push(
                //         <li className="check active" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                //             {/* <span> 23%</span> */}
                //             <AfshanRug
                //                 background={rug.background}
                //                 border={rug.border}
                //                 show={true}
                //             />
                //         </li>
                //     )
                //     break;
            }
            return ""
        })
        return (
            <div className="text-center selected-normal-display">
                <p> {this.props.texts["selectedRugs"]} </p>
                <ul className="normal-display">
                    {rugs}
                </ul>
            </div>
        )
    }
}